<template>
    <b-overlay :show="loading" rounded="sm">
    <div>
        <location-list v-if="isList" title="Locations Management" :loading="loading" ref="table">
        </location-list>
        <location-view v-else ref="locationView" :id="id" :loading="loading" @save-location="saveLocation"
            @delete-section="deleteSection" @save-section="saveSection" @delete-location="deleteLocation" />
    </div>
    </b-overlay>
</template>
<script>
import LocationList from './LocationList'
import LocationView from './LocationView'

import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

import showItemHelper from '@/mixins/showItemHelper'

const noneError = 'NoneError'
const invalidNameError = 'InvalidName'

export default {
    name: 'locations',
    components: {
        LocationList,
        LocationView,
    },
    mixins: [popupMixins, permissionsMixins, showItemHelper],
    data() {
        return {
            loading: false,
        }
    },
    computed: {
        componentName() { return this.$translate('location') },
    },

    methods: {
        async saveLocation(payload) {
            try {
                this.loading = true
                const id = payload.id
                delete payload.id
                const path = id ? 'locations/update' : 'locations/create'
                const action = id ? this.$translate('updated') : this.$translate('created')
                const type = 'success'
                await this.$store.dispatch(path, { id, payload })

                this.genericToast(
                    this.componentName,
                    action,
                    type,
                    id ?
                        `${this.componentName} ${this.$translate('update_alert')}` :
                        `${this.componentName} ${this.$translate('create_alert')}`
                )
                //this.doToast('Success!', title, type)
                this.$router.go(-1)
            } catch (error) {
                this.doToast(this.$translate('error'), error.message, 'danger')
            } finally {
                this.loading = false
            }
        },

        /**
         * Stores the section data
         */
        async saveSection({ section, location_id }) {
            try {
                this.loading = true
                console.log('section', section)
                console.log('location_id', location_id)
                const { id, name, is_officer } = section

                // Check if the Section is empty
                if (!/^[a-z][a-z\d\-_\s]+$/i.test(name)) {
                    throw invalidNameError
                }
                // const { id: location_id } = this.item
                const payload = { name, is_officer }
                const path = id
                    ? 'locations/updateSection'
                    : 'locations/createSection'

                await this.$store.dispatch(path, {
                    location_id,
                    id,
                    payload,
                })

                console.log('Location is ', this.locationSections)
                this.genericToast(this.componentName, this.$translate('created'), 'success', `${this.componentName} ${this.$translate('section')} ${this.$translate('create_alert')}`)
            } catch (error) {
                console.error('saveSection', (error && error.message) || error)
                if (error === invalidNameError) {
                    this.doToast(
                        `${this.$translate('error')}`,
                        this.$translate('invalid_section_name'),
                        'danger'
                    )
                } else {
                    this.doToast(`${this.$translate('error')}`, this.$translate('unable_section'), 'danger')
                }
            } finally {
                this.loading = false
                this.$forceUpdate()
            }
        },

        async deleteLocation(id) {
            try {
                const result = await this.confirmMessage(
                    `${this.$translate('delete_location')}?`,
                    `${this.$translate('delete_note')} ${this.componentName}?`
                )

                if (!result) {
                    throw noneError
                }
                this.loading = true
                await this.$store.dispatch('locations/delete', id)

                this.genericToast(this.componentName, this.$translate('deleted'), 'success', `${this.componentName} ${this.$translate('delete_alert')} `)

            } catch (error) {
                console.error(error)
                if (error != noneError) {
                    this.doToast(
                        this.$translate('error'),
                        this.$translate('unable_to_delete_location'),
                        'danger'
                    )
                }
            } finally {
                this.loading = false
                this.$router.go(-1)
            }
        },

        async deleteSection({ id, location_id }) {
            try {

                const result = await this.confirmMessage(
                    `${this.$translate('delete_location')} ${this.$translate('section')}?`,
                    `${this.$translate('delete_note')} ${this.$translate('location_section')}?`
                )

                if (!result) {
                    throw noneError
                }
                this.loading = true
                await this.$store.dispatch('locations/deleteSection', {
                    id,
                    location_id,
                })

                this.genericToast(this.componentName, this.$translate('deleted'), 'success', `${this.$translate('location_section')} ${this.$translate('delete_alert')}`)

            } catch (error) {
                console.log('error message', error)
                if (error != noneError) {
                    const message =
                        this.$translate('delete_section')
                    this.doToast(this.$translate('error'), message, 'danger')
                }
            } finally {
                this.loading = false
            }
        },
    },
}
</script>
<style></style>
